// extracted by mini-css-extract-plugin
export default {"wrapper":"NotificationsAndAccounts_wrapper__GdMJi"};